import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatButton } from "@angular/material/button";
import { MatOption } from "@angular/material/core";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatSelect } from "@angular/material/select";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Nullable } from "@playcharge/common/models/backend/nullable";
import { MatInput } from "@angular/material/input";
import { CreateOfferEditModel } from "@playcharge/common/models/backend/offers/backoffice/create-offer-edit-model";
import { ClientViewModel } from "@playcharge/common/models/backend/clients/client-view-model";
import { OfferType } from "@playcharge/common/models/backend/offers/offer-type";
import { EnumKeyValuePipe } from "../../../pipes/enumKeyValue.pipe";

@Component({
    selector: "app-create-offer-dialog",
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        MatSelect,
        MatOption,
        EnumKeyValuePipe,
        MatButton,
    ],
    templateUrl: "./create-offer-dialog.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateOfferDialogComponent {
    private _selfRef: MatDialogRef<CreateOfferDialogComponent, CreateOfferEditModel> = inject(
        MatDialogRef<CreateOfferDialogComponent, CreateOfferEditModel>,
    );

    public data: Nullable<ClientViewModel[]> = inject(MAT_DIALOG_DATA);

    public form = new FormGroup({
        serviceTitle: new FormControl<string>("", {
            nonNullable: true,
            validators: [Validators.required],
        }),
        offerType: new FormControl<OfferType>(OfferType.Game, { nonNullable: true }),
        clientId: new FormControl<number>(0, { nonNullable: true }),
    });

    public OfferType = OfferType;

    public close(): void {
        this._selfRef.close(this.form.getRawValue());
    }
}
